import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getPedidos } from '../api/pedidos';
import useSEO from '../hooks/useSEO';
import logo from '../logo.jpg';
import './Home.css';
import './Carrito.css';
import './MisPedidos.css';

// El backend manda creado_en como "AAAA-MM-DD HH:mm:ss" (espacio, no "T"),
// que Date no siempre parsea bien -- se normaliza antes de intentarlo.
const formatFecha = (value) => {
  if (!value) return '';
  const normalized = value.includes('T') ? value : value.replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('es-UY', { day: 'numeric', month: 'long', year: 'numeric' });
};

const describePersonalizacion = (personalizacion) => {
  if (!personalizacion || typeof personalizacion !== 'object') return '';
  return Object.values(personalizacion).filter(Boolean).join(' · ');
};

const MisPedidos = () => {
  useSEO({
    title: 'Mis Pedidos | MiEstampita',
    description: 'Revisá el historial de tus pedidos en MiEstampita.',
    path: '/mis-pedidos',
    noindex: true,
  });

  const { isLoggedIn } = useAuth();
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isLoggedIn) {
      setLoading(false);
      return;
    }
    getPedidos()
      .then(setPedidos)
      .catch((err) => setError(err.message || 'No se pudieron cargar tus pedidos.'))
      .finally(() => setLoading(false));
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return (
      <div className="home-page">
        <div className="logo-wrapper">
          <Link to="/">
            <img src={logo} alt="MiEstampita Logo" className="logo" />
          </Link>
        </div>
        <div className="home-wrapper">
          <p>Iniciá sesión para ver tus pedidos.</p>
          <Link to="/login" className="back-to-collection">
            Iniciar sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt="MiEstampita Logo" className="logo" />
        </Link>
      </div>
      <div className="home-wrapper">
        <Link to="/coleccion" className="back-to-collection">
          ‹ Seguir comprando
        </Link>
        <h1 className="selected-title">Mis Pedidos</h1>

        {loading && <p>Cargando pedidos...</p>}
        {error && <p className="cart-cupon__error">{error}</p>}
        {!loading && !error && pedidos.length === 0 && <p>Todavía no hiciste ningún pedido.</p>}

        {!loading && pedidos.length > 0 && (
          <ul className="pedidos-list">
            {pedidos.map((pedido) => (
              <li key={pedido.id} className="pedido-card">
                <div className="pedido-card__header">
                  <span>Pedido #{pedido.id}</span>
                  <span>{formatFecha(pedido.creado_en)}</span>
                  <span className="pedido-card__estado">{pedido.estado}</span>
                </div>
                <ul className="pedido-card__items">
                  {pedido.items.map((item, index) => (
                    <li key={index}>
                      {item.nombre_producto} × {item.cantidad}
                      {describePersonalizacion(item.personalizacion) && (
                        <span className="pedido-card__personalizacion">
                          {' '}
                          — {describePersonalizacion(item.personalizacion)}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
                <div className="pedido-card__total">Total: ${pedido.total}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MisPedidos;
